module.exports = __webpack_public_path__ + "static/media/galerija_2023 (20).f5f3b742.png";